
export const ShotTypes = [
    'Wide',
    'Medium', 
    'Close-up',
    'Extreme Close-up',
    'Over the Shoulder',
    'POV',
    'Aerial',
    'Low Angle',
    'High Angle',
    'Dutch Angle',
    'Establishing',
    'Master Shot',
    'Insert',
    'Other'
] as const;

export const CameraMovements = [
    'Static',
    'Pan',
    'Tilt',
    'Dolly',
    'Zoom',
    'Tracking',
    'Handheld',
    'Crane',
    'Steadicam',
    'Gimbal',
    'Whip Pan',
    'Other'
] as const;

export const CameraAngles = [
    'Eye Level',
    'High Angle',
    'Low Angle',
    'Bird\'s Eye',
    'Worm\'s Eye',
    'Canted/Dutch',
    'Overhead',
    'Other'
] as const;

export const Framings = [
    'Single',
    'Two-Shot',
    'Three-Shot',
    'Group Shot',
    'Over the Shoulder',
    'Crowd',
    'Other'
] as const;

export const ShotPriorities = [
    'Must Have',
    'Good to Have',
    'Optional'
] as const;

export const Moods = [
    'Tense',
    'Melancholic',
    'Fast-paced',
    'Dreamy',
    'Action-packed',
    'Dramatic',
    'Romantic',
    'Dark',
    'Lighthearted',
    'Mysterious',
    'Serene'
] as const;

export const VisualStyles = [
    'Handheld',
    'Cinematic',
    'Noir',
    'Documentary',
    'Minimalist',
    'High Contrast',
    'Pastel',
    'Cyberpunk',
    'Surreal'
] as const;

export const FieldHelpers = {
    shotType: "The size of the subject in the frame (e.g., Wide, Close-up).",
    cameraAngle: "The vertical position of the camera relative to the subject.",
    cameraMovement: "How the camera moves during the shot.",
    framing: "Who or what is in the frame and how they are arranged.",
    subject: "The main focus of the shot (character, object, or scenery).",
    description: "A brief description of the action or visual content.",
    emotionalPurpose: "The feeling or narrative goal this shot conveys (e.g., tension, isolation).",
    duration: "Estimated length of the shot in seconds.",
    shotPriority: "Importance of getting this shot during production."
};
